import SubcategoryPage from '@/components/template/SubcategoryPage';

const TanchoStool = () => {
  const products = [
    {
      title: "Tancho Stool Light",
      imageSrc: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?auto=format&fit=crop&q=80",
      url: "/proizvodi/tancho-stool-light"
    },
    {
      title: "Tancho Stool Dark",
      imageSrc: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?auto=format&fit=crop&q=80",
      url: "/proizvodi/tancho-stool-dark"
    },
    {
      title: "Tancho Stool Natural",
      imageSrc: "https://images.unsplash.com/photo-1528698827591-e19ccd7bc23d?auto=format&fit=crop&q=80",
      url: "/proizvodi/tancho-stool-natural"
    }
  ];

  return (
    <SubcategoryPage
      title="Tancho Stool"
      description="Elegantni Tancho stolčki, navdihnjeni z japonskim minimalizmom, za ustvarjanje mirne in uravnotežene atmosfere."
      heroImage="https://images.unsplash.com/photo-1580480055273-228ff5388ef8?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default TanchoStool;